<div class="dynamic-form">
    <div class="step-wrapper">
        <div class="modal-body">
            <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
            <p>
                {{
                    step.step_type_id === STEP_TYPES.LICENSE_VERIFICATION
                        ? 'The following information needs to be provided to verify the current status of '
                        : 'The following information needs to be provided to renew '
                }}
                {{ step.certification_name }} {{ step.acronym }}
            </p>
            <p *ngIf="step.content.url">
                Please <a class="cm-link" [href]="step.content.url" target="_blank">click here</a>
                {{
                    step.step_type_id === STEP_TYPES.LICENSE_VERIFICATION
                        ? ' to check the current status.'
                        : ' to renew the credential.'
                }}
            </p>

            <cm-dynamic-form
                *ngIf="isStepSubmitted || formInfo?.fields"
                [isZeroValueAllowed]="true"
                [elements]="elements"
                [disabled]="isStepSubmitted"
                [showErrors]="showErrors"
                [sections]="step.content.sections"
                class="form"
                [showAllCustomErrors]="step.typeId === STEP_TYPES.LICENSE_VERIFICATION"
                (updateFieldValue)="updateFieldValue($event)"
            ></cm-dynamic-form>
            <div class="signature-container">
                <cm-signature
                    #signature
                    *ngIf="
                        afterView && (formInfo?.signature_required || (isStepSubmitted && step.content.signature_link))
                    "
                    class="signature-bar"
                    [class.signature-bar--full]="!isStepSubmitted"
                    [editable]="!isStepSubmitted"
                ></cm-signature>
            </div>
            <cm-inline-error class="error-block" [errorMessages]="formErrors" *ngIf="showErrors"></cm-inline-error>
        </div>
        <div class="modal-footer">
            <button *ngIf="!isStepSubmitted" type="button" class="btn btn-default" (click)="dismissModal()">
                BACK
            </button>
            <button *ngIf="!isStepSubmitted" type="button" class="btn btn-primary" (click)="submitForm()">
                SUBMIT
            </button>
            <button *ngIf="isStepSubmitted" type="button" class="btn btn-primary" (click)="dismissModal()">
                CLOSE
            </button>
        </div>
    </div>
</div>
